const SPECIES = Object.freeze({
  SHEEP: {
    id: "OVCA",
    code: 1,
    translationKey: "species.SHEEP",
  },
  GOAT: {
    id: "KOZA",
    code: 2,
    translationKey: "species.GOAT",
  },
  EQUINE: {
    id: "KONJ",
    code: 3,
    translationKey: "species.EQUINE",
  },
  PIG: {
    id: "PRASIC",
    code: 4,
    translationKey: "species.PIG",
  },
  COW: {
    id: "GOVEDO",
    code: 4,
    translationKey: "species.PIG",
  },
});

export const SHEEP_GOAT_SPECIES_LIST = Object.freeze([
  SPECIES.SHEEP,
  SPECIES.GOAT,
]);

export default SPECIES;
